<template>
	<footer></footer>
</template>

<script>
export default {
	name: "CommonFooter"
}
</script>